<mat-dialog-content class="mat-dialog--task">
    <app-shared-task *ngIf="task.uid && user.uid" [taskInp]="task" [userInp]="user" [viewInp]="'dialog'" class="app-shared-task"></app-shared-task>
</mat-dialog-content>
